var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"eg-tabs"},[_c('b-tabs',_vm._g(_vm._b({staticClass:"eg-tabs__container d-flex flex-column overflow-auto",attrs:{"nav-class":"eg-tabs__nav no-print","nav-item-class":"eg-tabs__nav-item"}},'b-tabs',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }